"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var storage_service_1 = require("../modules/storage/storage.service");
var user_service_1 = require("./user.service");
var constants_1 = require("../constants");
var lodash_1 = __importDefault(require("lodash"));
var services_1 = require("../generated/services");
var i0 = __importStar(require("@angular/core"));
var i1 = __importStar(require("../modules/storage/storage.service"));
var i2 = __importStar(require("./user.service"));
var i3 = __importStar(require("../generated/services/user-module-access-client.service"));
var AuthorizationService = /** @class */ (function () {
    function AuthorizationService(storageService, userService, userModuleAccessClient) {
        this.storageService = storageService;
        this.userService = userService;
        this.userModuleAccessClient = userModuleAccessClient;
    }
    /**
     * Gets an array of access right IDs for the current user.
     * from the server.
    */
    AuthorizationService.prototype.getModuleIds = function (dealerIds) {
        var _this = this;
        return this.getAccessRightsAndModules()
            .then(function (result) {
            var moduleIds = _this.convertToModuleIds(result.modules, dealerIds);
            _this.storageService.setItem('moduleIds', moduleIds);
            return moduleIds;
        });
    };
    AuthorizationService.prototype.getModuleIdsFromCache = function (dealerIds) {
        var moduleIds = this.storageService.getItem(constants_1.StorageKeys.ModuleIds);
        if (moduleIds && moduleIds.length > 0) {
            return Promise.resolve(moduleIds);
        }
        return this.getModuleIds(dealerIds);
    };
    AuthorizationService.prototype.getAccessRightIdsFromCache = function (dealerIds) {
        var accessRightIds = this.storageService.getItem(constants_1.StorageKeys.AccessRightIds);
        if (accessRightIds && accessRightIds.length > 0) {
            return Promise.resolve(accessRightIds);
        }
        return this.getAccessRightIds(dealerIds);
    };
    /**
     * Gets an array of access right IDs for the current user.
     * from the server.
    */
    AuthorizationService.prototype.getAccessRightIds = function (dealerIds) {
        var _this = this;
        return this.getAccessRightsAndModules()
            .then(function (result) {
            var accessRightIds = _this.convertToAccessRightIds(result.accessRights, dealerIds);
            _this.storageService.setItem('accessRightIds', accessRightIds);
            return accessRightIds;
        });
    };
    AuthorizationService.prototype.getAccessRightsAndModules = function () {
        var _this = this;
        if (!this.userModuleAccessPromise) {
            this.userModuleAccessPromise = this.userModuleAccessClient.GET().toPromise()
                .then(function (response) {
                _this.userModuleAccessPromise = null;
                return response;
            });
        }
        return this.userModuleAccessPromise;
    };
    AuthorizationService.prototype.getDealerModules = function () {
        return __awaiter(this, void 0, void 0, function () {
            var userProfile;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.userService.getUserProfile()];
                    case 1:
                        userProfile = _a.sent();
                        return [2 /*return*/, userProfile.dealerModules];
                }
            });
        });
    };
    AuthorizationService.prototype.isAuthorized = function (permissionValue) {
        var accessRightIds = this.storageService.getItem('accessRightIds');
        if (accessRightIds) {
            return accessRightIds.indexOf(permissionValue) > -1;
        }
        else {
            return false;
        }
    };
    AuthorizationService.prototype.getUserCountryID = function () {
        var savedCultureName = this.storageService.getItem('cultureName');
        var cultureName = savedCultureName ? savedCultureName : 'en-us';
        cultureName = cultureName.toLowerCase();
        switch (cultureName) {
            case 'en-gb':
                return 3;
            case 'en-ca':
                return 2;
            case 'fr-ca':
                return 2;
            case 'en-us':
                return 1;
            default:
                return 0;
        }
    };
    AuthorizationService.prototype.getUserCultureName = function () {
        var savedCultureName = this.storageService.getItem('cultureName');
        var cultureName = savedCultureName ? savedCultureName : 'en-us';
        cultureName = cultureName.toLowerCase();
        return cultureName;
    };
    AuthorizationService.prototype.getDealSheetPermissions = function (accessRightIds) {
        if (accessRightIds && accessRightIds.length > 0) {
            this.storageService.setItem(constants_1.StorageKeys.AccessRightIds, accessRightIds);
        }
        var permissions = {
            serviceHistory: this.isAuthorized(constants_1.AuthorizationKeys.ServiceHistory),
            viewCustomer: this.isAuthorized(constants_1.AuthorizationKeys.ViewCustomer),
            viewVehicle: this.isAuthorized(constants_1.AuthorizationKeys.VehicleDetails),
            viewContract: this.isAuthorized(constants_1.AuthorizationKeys.SaleDetails),
            viewChangeLog: this.isAuthorized(constants_1.AuthorizationKeys.ChangeLog),
            viewInventory: this.isAuthorized(constants_1.AuthorizationKeys.Inventory),
            viewTradeValue: this.isAuthorized(constants_1.AuthorizationKeys.TradeValue),
            editMileage: this.isAuthorized(constants_1.AuthorizationKeys.Odometer),
            editContract: this.isAuthorized(constants_1.AuthorizationKeys.Sale),
            editConquestContract: this.isAuthorized(constants_1.AuthorizationKeys.ConvertService),
            editPrice: this.isAuthorized(constants_1.AuthorizationKeys.Price),
            editCustomer: this.isAuthorized(constants_1.AuthorizationKeys.EditCustomer),
            editAssignedUser: this.isAuthorized(constants_1.AuthorizationKeys.Reassign),
            editActivity: this.isAuthorized(constants_1.AuthorizationKeys.PostActivity),
            editPayoffAmount: this.isAuthorized(constants_1.AuthorizationKeys.Payoff),
            editMarkAsNotOwn: this.isAuthorized(constants_1.AuthorizationKeys.MarkAsNotOwn),
            editMarkAsSold: this.isAuthorized(constants_1.AuthorizationKeys.MarkAsSold),
            editMarkAsPaidOff: this.isAuthorized(constants_1.AuthorizationKeys.MarkAsPaidOff),
            editMarkAsWarranty: this.isAuthorized(constants_1.AuthorizationKeys.MarkAsWarranty),
            editMarkAsWatch: this.isAuthorized(constants_1.AuthorizationKeys.MarkAsWatch),
            warranty: this.isAuthorized(constants_1.AuthorizationKeys.Warranty),
            activitiesLog: this.isAuthorized(constants_1.AuthorizationKeys.ActivitiesLog),
            postActivity: this.isAuthorized(constants_1.AuthorizationKeys.PostActivity),
            print: this.isAuthorized(constants_1.AuthorizationKeys.Print),
            printTemplate: this.isAuthorized(constants_1.AuthorizationKeys.PrintTemplate),
            requestCreditPrescreen: this.isAuthorized(constants_1.AuthorizationKeys.CreditConvertSoftPullManual),
            emailTemplate: this.isAuthorized(constants_1.AuthorizationKeys.EmailTemplate),
            vehicleHistoryReports: this.isAuthorized(constants_1.AuthorizationKeys.VehicleHistoryReports),
            payments: this.isAuthorized(constants_1.AuthorizationKeys.Payments),
            paymentDetails: this.isAuthorized(constants_1.AuthorizationKeys.PaymentDetails),
            editDoNotContact: this.isAuthorized(constants_1.AuthorizationKeys.DoNotContact),
            viewAlertScripts: this.isAuthorized(constants_1.AuthorizationKeys.Script),
            manageSearches: this.isAuthorized(constants_1.AuthorizationKeys.ManageSearches),
            sendTextSales: this.isAuthorized(constants_1.AuthorizationKeys.SendTextSales),
            sendTextService: this.isAuthorized(constants_1.AuthorizationKeys.SendTextService),
            crossBrandMVO: this.isAuthorized(constants_1.AuthorizationKeys.CrossBrandMVO)
        };
        return Promise.resolve(permissions);
    };
    AuthorizationService.prototype.convertToModuleIds = function (modules, dealerIds) {
        return modules
            // Only include modules linked to our current dealers
            .filter(function (module) {
            return lodash_1.default.some(lodash_1.default.intersection(module.moduleDealerIds, dealerIds));
        })
            .map(function (module) { return module.moduleId; });
    };
    AuthorizationService.prototype.convertToAccessRightIds = function (accessRights, dealerIds) {
        return lodash_1.default.uniq(accessRights
            // Only include access rights for our current dealers
            .filter(function (accessRight) {
            return lodash_1.default.some(lodash_1.default.intersection(accessRight.accessRightDealerIds, dealerIds));
        })
            .map(function (accessRight) { return accessRight.accessRightId; }));
    };
    AuthorizationService.prototype.isEuroLite = function () {
        var userProfile = this.storageService.getItem('userProfile');
        if (userProfile) {
            return userProfile.isLiteUser;
        }
        return false;
    };
    AuthorizationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthorizationService_Factory() { return new AuthorizationService(i0.ɵɵinject(i1.StorageService), i0.ɵɵinject(i2.UserService), i0.ɵɵinject(i3.UserModuleAccessClientService)); }, token: AuthorizationService, providedIn: "root" });
    return AuthorizationService;
}());
exports.AuthorizationService = AuthorizationService;
